import React from "react";
import PropTypes from "prop-types";
import styles from "./PurchasedModal.module.css";
import purchasedIcon from "../../assets/Purchased_Icon_Blue.png";
import closeButtonIcon from "../../assets/Close_Button.svg";
import { useTranslation } from "react-i18next";

export function PurchasedModal({ onClose, isOpen }) {
  const handleClose = () => {
    onClose();
  };
  const {t} = useTranslation();

  return (
    <>
      {isOpen && (
        <div className={styles.modalOverlay}>
          <div className={styles.modalContent}>
            <div className={styles.modalHeader}>
              <img
                src={purchasedIcon}
                alt="Purchased Icon"
                className={styles.purchasedIcon}
              />
              <p>{t("HomeSite Locked")}</p>
              <div className={styles.closeButton} onClick={handleClose}>
                <img src={closeButtonIcon} alt="Close Button" />
              </div>
            </div>
            <div className={styles.modalBody}>
              <p>
                {t("You have already purchased tickets")}
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

PurchasedModal.propTypes = {
  onClose: PropTypes.func,
  isOpen: PropTypes.bool,
};
